// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dash-module_dashWrapper__r75_I {
    cursor: pointer;
    width: 100%;
    padding: 12px 0;
    display: flex;
    justify-content: center;
    align-items: center;
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/common/dash.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,WAAW;IACX,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":[".dashWrapper {\n    cursor: pointer;\n    width: 100%;\n    padding: 12px 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashWrapper": `dash-module_dashWrapper__r75_I`
};
export default ___CSS_LOADER_EXPORT___;
